export default __webpack_public_path__ + "static/media/Constellation_010604.8d54e5aa.jpg";